import { useState, useCallback } from 'react';

/**
 * Manages modal open/close state plus the selected record.
 *
 * Replaces the repeated pattern in Dashboard:
 *   const [isModalOpen, setIsModalOpen] = useState(false);
 *   const [recordToEdit, setRecordToEdit] = useState(null);
 *   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
 *   const [recordToDelete, setRecordToDelete] = useState(null);
 */
export function useModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [record, setRecord] = useState(null);

  const open = useCallback((rec = null) => {
    setRecord(rec);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setRecord(null);
  }, []);

  return { isOpen, record, open, close };
}
